<header class="header">
    <nav class="header__nav">
        <div>
            <app-sidebar></app-sidebar>
        </div>

        <a class="header__item header__item--logo" [routerLink]="session.preferredUrl()">
            <img src="assets\icons\header\next-gradient.svg" alt="NEXT" class="header__logo-img">
        </a>

        <div class="header__item header__item--infrastructure">
            @if(listValue) {
                <app-str-header-selector></app-str-header-selector>
            }
        </div>

        <div class="header__item header__item--language">
            <app-language-selector></app-language-selector>
        </div>

        <div class="header__item header__item--user">
            <app-user-menu></app-user-menu>
        </div>

        <div class="header__item header__item--clock">
            <app-clock></app-clock>
        </div>
    </nav>
</header>
